import React from 'react'

export default ({ onClickBack, onClickToPaid }) => (
  <div className="page__popup">
    <div className="page__popup-col1">
      <p className="page__popup__cancel search-change__cancel">
        <a href="#" onClick={onClickBack}>
          <span className="page__popup__cancel-icon search-change__cancel-icon">
            ×
          </span>
        </a>
      </p>
      <div className="popup-headline">
        <h2 className="popup-headline__title">再審査申請が必要です</h2>
        <p className="popup-headline__text">
          情報は保存されましたが、Paid上でも変更が必要です。
          <br />
          お手数ですが、Paid（株式会社ラクーンフィナンシャル）ログインページから情報の変更を行ってください。
        </p>
      </div>
      <div className="confirm-modal__button">
        <input
          type="button"
          name="commit"
          value="Paidへ移動する"
          className="button-green mr5 pt15 pb15 w400 sm-w100"
          onClick={onClickToPaid}
        />
      </div>
    </div>
  </div>
)
